import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import OrganizationEventChip from '@/modules/Organizations/components/info/OrganizationEventChip.vue'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import { Organization } from '@/modules/Organizations/types'
import { eventApi, IEventPeriod, IEventPeriodStats } from '@/enitites/event'
import { IEventPreview } from '@/enitites/event/model/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationEvents',
  props: {
    org: null
  },
  setup(__props: any) {

const props = __props as {
  org: Organization
};



const currentTab = ref<IEventPeriod | undefined>()
const tabTitles: Record<IEventPeriod, string> = {
  now: 'Happening',
  past: 'Past',
  future: 'Upcoming',
  draft: 'Drafts',
}

const tabs = ref<IEventPeriodStats>()
const infiniteLoaderId = ref<number>(+new Date())
const pageSize = ref(8)
const pageNumber = ref(0)
const events = ref<IEventPreview[]>([])
const sortDirection = ref<'asc' | 'desc'>('asc')
const defaultSortDirections = ref<Record<string, 'asc' | 'desc'>>({
  now: 'asc',
  past: 'desc',
  future: 'asc',
  draft: 'desc',
})
const sortBy = ref<'date' | 'title'>('date')

const existedTabs = computed((): IEventPeriod[] => {
  if (!tabs.value) return []
  return Object.keys(tabs.value).filter((t) => tabs.value?.[t as keyof IEventPeriodStats]) as IEventPeriod[]
})

async function fetchTabs() {
  const data = await eventApi.getEventsAvailableTabs({ orgId: props.org.id })
  if (data) {
    tabs.value = data
    currentTab.value = Object.entries(data).find(([, value]) => value > 0)?.[0] as IEventPeriod
  }
}

function selectTab(tab: IEventPeriod) {
  sortDirection.value = defaultSortDirections.value[tab]
  currentTab.value = tab
}

async function loadEvents($state: { complete: () => void; loaded: () => void }) {
  if (!currentTab.value) return
  const searchParams = {
    pageNumber: pageNumber.value,
    pageSize: pageSize.value,
    tab: currentTab.value,
    orgIds: [props.org.id],
    sortBy: `${sortBy.value}-${sortDirection.value}`,
  }

  const data = await eventApi.getEvents(searchParams)

  if (!data || typeof data === 'string') {
    return
  }
  pageNumber.value += 1
  events.value.push(...data)
  if (data.length < pageSize.value) $state.complete()
  else $state.loaded()
}

function resetLoading() {
  pageNumber.value = 0
  events.value = []
  infiniteLoaderId.value += 1
}

watch([currentTab, sortDirection, sortBy], () => resetLoading())

onMounted(async () => {
  await fetchTabs()
})

return { __sfc: true,props, currentTab, tabTitles, tabs, infiniteLoaderId, pageSize, pageNumber, events, sortDirection, defaultSortDirections, sortBy, existedTabs, fetchTabs, selectTab, loadEvents, resetLoading, OrganizationEventChip, mdiChevronDown, mdiChevronUp }
}

})